import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'la-upgrade-tag',
  imports: [MatIconModule],
  templateUrl: './upgrade-tag.component.html',
  styleUrl: './upgrade-tag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeTagComponent {}
